import { Swiper, Navigation, Pagination, Scrollbar, EffectCoverflow, Parallax, EffectFade } from 'swiper';
Swiper.use([Navigation, Pagination, Scrollbar, EffectCoverflow, Parallax,EffectFade]);
import stickybits from 'stickybits'
import MaterialMarketoForm from '../components/MaterialMarketoForm'

/** Team Modal events. */
const teamModals = () => {
  $('[open-modal]').on('click', function(){
    var id = $(this).attr('open-modal');
    $('.modal#'+id).addClass('active');
  });
  $('[close-modal]').on('click', function(){
    $(this).parents('.modal').removeClass('active');
  });
  $('.modal').on('click', function(e) {
    if(e.target !== this){return}
    $(this).removeClass('active');
  });
}

/**
 * The hello bar plugin doesn't have target="_blank" as an option. 
 * Force hello bar links to open in a new tab.
 */
const helloBarTargetBlank = () => {
  if(document.querySelectorAll('.mtsnb-link')){
    document.querySelectorAll('.mtsnb-link').forEach(link => link.target = '_blank')
  }
}

/**
 * Set the background behind the footer wave to match the previous 
 * element.
 */
const footerWaveBackgroundColor = () => {
  const lastEl = document.querySelector('.main').lastElementChild,
    lastCol = lastEl.style.backgroundColor

  document.querySelector('.footer-flourish').style.backgroundColor = lastCol
}

export default {
  init() {
    // JavaScript to be fired on all pages
    window.Swiper = Swiper
    window.dispatchEvent(new CustomEvent('js-loaded'))

    if(0 < document.querySelectorAll('.acf\\/marketo-form').length){
      new MaterialMarketoForm()
    }

    // MEGA MENU
    $('#menu-primary-navigation > li').on('click', function(e) {
      e.stopPropagation()
      if($(this).hasClass('active')){
        $(this).removeClass('active');
        $(this).children('.pane').removeClass('active');
        $('.site-header').removeClass('pane-open');
        
      }else{
        $(this).siblings().removeClass('active');
        $(this).siblings().children('.pane').removeClass('active');
        $(this).addClass('active');
        $(this).children('.pane').addClass('active');
        $(this).children('.pane').addClass('active').show(500);
        $('.site-header').addClass('pane-open');
      }
    });
    $('#menu-primary-navigation > li .pane').on('click', ':not(a)', function(e) {
      e.stopPropagation()
    });
    $('.submenu-item a').on('click', function() {
      $('.pane').removeClass('active');
      $('#menu-primary-navigation > li').removeClass('active');
      $('[data-toggle-mobile-nav]').toggleClass('active')
      $('body').toggleClass('mobile-nav-active')
      $('.nav-container').removeClass('open-pane')
    });
    $(document).on('click', function() {
      if(!$('body').hasClass('mobile-nav-active')) {
        if ($('[data-pane]').hasClass('active')){
          $('.pane').removeClass('active');
          $('#menu-primary-navigation > li').removeClass('active');
          $('.site-header').removeClass('pane-open');
        }
      }
    });

    teamModals()

    //Quote Carousel arrows
    if ($('section').hasClass('quote-carousel')) {
      $('.quote-carousel').each(function() {
        var slides = $(this).find('.swiper-slide');
        var arrowPrev = $(this).find('.swiper-button-prev');
        var arrowNext = $(this).find('.swiper-button-next');
        if (slides.length <= 1 ) {
            arrowPrev.css('display', 'none');
            arrowNext.css('display', 'none');
        }
      });
    }

    // Allow mobile nav items to collapse
    $('label.mtc-label').on('click', function() {
      if($(this).parent().siblings('input').is(':checked')) {
        var $radio = $(this).parent().siblings('input');
        $radio.attr('disabled', true);
        setTimeout(function() { 
            $radio.attr('disabled', false);
            $radio.prop('checked', false);
        }, 10);
      }
    });

    //GRAVITY FORMS - MATERIAL DSIGN - ADD FOCUS TO LABEL
    var fields = $('form input, form textarea, form select');
    fields.each(function(){
      var input = $(this);
      if( input.val().length === 0 ){
        input.parent().siblings('label').removeClass('focused');
      } else {
        $(this).parent().siblings('label').addClass('focused');
      }
    });
        
    $('form input, form textarea, form select').focusin(function(){
      $(this).parent().siblings('label').addClass('focused');
    });

    $('form input, form textarea, form select').focusout(function(){
      var input = $(this);
      if( input.val().length === 0 ){
        input.parent().siblings('label').removeClass('focused');
      }
    });
    //Modals
    $('[open-modal]').on('click', function(){
      var modalId = $(this).attr('open-modal');
      $('#' + modalId).addClass('active');
    });
    $('.modal').on('click', function(e){
      e.preventDefault()
      if(e.target.id == 'close-modal' || e.target.classList.contains('modal')){
        if($(this).find('iframe')){
          var videoIframe = $(this).find('iframe').attr('src');
          var video = $(this).find('video').attr('src');
          $(this).removeClass('active');
          $(this).find('iframe').attr('src','');
          $(this).find('iframe').attr('src', videoIframe);
          $(this).find('video').attr('src','');
          $(this).find('video').attr('src', video);
        }
      }
      
    });

  },
  finalize() {
    helloBarTargetBlank()
    footerWaveBackgroundColor()
    stickybits('.banner', {useStickyClasses: true})
    initSwiper()
  },
};


const initSwiper = () => {
  if(0 < document.querySelectorAll('.carousel-container').length){
    const swiper = new Swiper('.carousel-container', {
      // Optional parameters
      effect: 'fade',
      fadeEffect: {
        crossFade: true,
      },
      parallax: true,
      spaceBetween: 100,
      preloadImages: true,
      loop: true,
      speed: 800,
      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    })
    setTimeout(() => {
      swiper.update()
    }, 500)
  }

  if(0 < document.querySelectorAll('.teamSwiper').length){
    const swiper = new Swiper('.teamSwiper', {
      // Optional parameters
      slidesPerView: 1,
      spaceBetween: 16,
      loop: true,
      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 16,
        },
        768: {
          slidesPerView: 4,
          spaceBetween: 16,
        },
      },
    })
    setTimeout(() => {
      swiper.update()
    }, 500)
  }

  if(0 < document.querySelectorAll('.studiesSwiper').length){
    const swiper = new Swiper('.studiesSwiper', {
      // Optional parameters
      slidesPerView: 1,
      spaceBetween: 16,
      loop: true,
      // Navigation arrows
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        640: {
          slidesPerView: 2,
          spaceBetween: 25,
        },
        768: {
          slidesPerView: 3,
          spaceBetween: 25,
        },
      },
    })
    setTimeout(() => {
      swiper.update()
    }, 500)
  }

  // if(0 < document.querySelectorAll('.stepthreeSwiper').length){
  //   const swiper = new Swiper('.stepthreeSwiper', {
  //     // Optional parameters
  //     effect: 'fade',
  //     fadeEffect: {
  //       crossFade: true,
  //     },
  //     parallax: true,
  //     spaceBetween: 16,
  //     loop: true,
  //     // Navigation arrows
  //     navigation: {
  //       nextEl: '.swiper-button-next',
  //       prevEl: '.swiper-button-prev',
  //     },
  //     // Pagination controls
  //     pagination: {
  //       el: '.swiper-pagination',
  //       clickable: true,
  //     },
  //     autoHeight: true,
  //     breakpoints: {
  //       480: {
  //         autoHeight: false,
  //       },
  //     },
  //   })
  //   setTimeout(() => {
  //     swiper.update()
  //   }, 500)
  // }

}



// WEBPACK FOOTER //
// ./scripts/routes/common.js